import React from 'react';
import PropTypes from 'prop-types';

/**
 * Simple wrapper to reuse the metronic base form group classes
 */
export default function FormGroup({ error, className, skipWrapper, children }) {
  if (skipWrapper) return children;

  return (
    <div
      className={`form-group m-form__group ${
        error ? 'has-danger' : ''
      } ${className}`}
    >
      {children}
    </div>
  );
}

FormGroup.propTypes = {
  /** Additional class names */
  className: PropTypes.string,
  /** Standard react children to be wrapped */
  children: PropTypes.node.isRequired,
  skipWrapper: PropTypes.bool,
  error: PropTypes.string,
};

FormGroup.defaultProps = {
  className: '',
  skipWrapper: false,
  error: undefined,
};
